import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AccessibilityButtons from '../components/common/AccessibilityButtons';
import '../styles/AuthPages.css';

export default function LoginPage() {
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await login(email, password);
        } catch (err) {
            setError('Erro ao fazer login. Confira e-mail e senha.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* Navbar simples para login */}
            <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom">
                <div className="container">
                    <Link className="navbar-brand d-flex align-items-center" to="/">
                        <img src="/images/logo.svg" alt="MicroGestor Logo" width="32" height="32" className="me-2" />
                        <span className="fw-bold" style={{ color: '#6366f1' }}>MicroGestor</span>
                    </Link>
                    <div className="d-flex gap-2 align-items-center">
                        <AccessibilityButtons />
                        <Link to="/" className="btn btn-outline-primary btn-sm">Voltar ao início</Link>
                    </div>
                </div>
            </nav>

            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
                <form onSubmit={handleSubmit} className="card shadow-sm" style={{ maxWidth: 400, width: '100%' }}>
                    <div className="card-body">
                        <h1 className="h4 mb-3 text-center">MicroGestor</h1>
                        <p className="text-muted small text-center mb-4">
                            Acesse para controlar vendas, produtos e despesas.
                        </p>

                        {error && <div className="alert alert-danger py-2">{error}</div>}

                        <div className="mb-3">
                            <label className="form-label">E-mail</label>
                            <input
                                type="email"
                                className="form-control"
                                autoComplete="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Senha</label>
                            <input
                                type="password"
                                className="form-control"
                                autoComplete="current-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>

                        <button className="btn btn-primary w-100" type="submit" disabled={loading}>
                            {loading ? 'Entrando...' : 'Entrar'}
                        </button>

                        <div className="text-center mt-3">
                            <p className="text-muted small mb-2">Ainda não tem uma conta?</p>
                            <Link to="/registro" className="btn btn-outline-primary w-100">
                                Criar Conta Gratuita
                            </Link>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}
